import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer>
      <div className="f-logo">LIAM W <em>COACHING</em></div>
      <ul className="f-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/packages">Packages</Link></li>
        <li><Link to="/testimonials">Results</Link></li>
        <li><Link to="/faq">FAQ</Link></li>
        <li><Link to="/packages">Apply</Link></li>
      </ul>
      <div className="f-copy">© 2025 Liam W Coaching · All rights reserved</div>
    </footer>
  );
}
